import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const InterestingStocksPage = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default InterestingStocksPage;
